import React from 'react';
import { Card, Col, Modal, Row } from 'antd';
import { CloseModalIcon } from '@gtintel/platform-atoms';
import EditProjectSubjectForm from './EditProjectSubjectForm';
const EditProjectSubjectModal = ({
  hideModal,
  jurisdictions,
  isVisible,
  subject
}) => {
  return <Modal closeIcon={<CloseModalIcon />} footer={null} onCancel={hideModal} title="Edit Service" visible={isVisible}>
      <div>
        <Row>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Card bordered={false}>
              <EditProjectSubjectForm jurisdictions={jurisdictions} onCancel={hideModal} subject={subject} />
            </Card>
          </Col>
        </Row>
      </div>
    </Modal>;
};
export default EditProjectSubjectModal;